import { isValNull } from "../../utils";
import moment from "moment";
const excludedKeys = ["driver_photo", "address_doc", "aadhar_card_doc"];
const excludeKeysForQcApproveButton = [
  "driver_dob",
  "face_match_data",
  "phone_match_data",
  "device_match_data",
  "aadhar_profile",
  "aadhar_card_doc",
];
const checkDocTypeFilled = ["license_card_doc"];

export const shouldQcApproved = (initialState) => {
  let showQc = true;
  if (Object.keys(initialState).length > 0) {
    Object.keys(initialState).forEach((outerKey) => {
      const details = initialState[outerKey];
      if (typeof details === "object") {
        Object.keys(details).forEach((innerKey) => {
          const keyDetails = details[innerKey];
          if (
            !isValNull(keyDetails) &&
            typeof keyDetails === "object" &&
            !excludeKeysForQcApproveButton.includes(innerKey) &&
            !keyDetails.verified
          ) {
            showQc = false;
          }
        });
      }
    });
    return showQc;
  }
  return false;
};

export const handleQcValidations = (initialState) => {
  const errors = [];
  if (Object.keys(initialState).length > 0) {
    Object.keys(initialState).forEach((outerKey) => {
      const details = initialState[outerKey];
      if (typeof details === "object") {
        Object.keys(details).forEach((innerKey) => {
          //check for rejection reasons
          //check for value
          const keyDetails = details[innerKey];

          if (innerKey == "dl_doc" || innerKey == "rc_doc") {
              if (
                typeof keyDetails === "object" &&
                keyDetails.verified
              ) {
                  if(!keyDetails.expiry || keyDetails.expiry === "Invalid date"){
                      errors.push(`Please input expiry date for ${innerKey
                        .split("_")
                        .join(" ")
                        .toUpperCase()}`);
                  }
              } 
          }

          if (innerKey == "pucc_doc" || innerKey == "insurance_doc") {
            if (
              typeof keyDetails === "object" &&
              keyDetails.verified
            ) {
                if(!keyDetails.value || keyDetails.value === "Invalid date"){
                    errors.push(`Please input expiry date for ${innerKey
                      .split("_")
                      .join(" ")
                      .toUpperCase()}`);
                }
            } 
          }

          if (innerKey == "pan_card_doc") {
            if (
              typeof keyDetails === "object" &&
              keyDetails.verified != false &&
              keyDetails.dob != ""
            ) {
              let is18orAbove =
                moment().diff(moment(keyDetails.dob), "years") >= 18;
              if (!is18orAbove && keyDetails.verified === true) {
                errors.push("Rider's age is below 18, Please reject Qc!!");
              }
            } else if (
              typeof keyDetails === "object" &&
              keyDetails.verified == true &&
              keyDetails.dob == ""
            ) {
              errors.push(`Please input rider's date of birth in pan section!`);
            }
            if (
              typeof keyDetails === "object" &&
              keyDetails.verified == true &&
              (keyDetails.fathers_name == "" || !keyDetails.fathers_name)
            ) {
              errors.push("Please enter the father's name in the PAN section");
            }
          }
          if (innerKey == "bank_doc") {
            if (
              typeof keyDetails === "object" &&
              keyDetails.verified == true &&
              keyDetails.beneficiary_name == ""
            ) {
              errors.push(`Please enter beneficiary name for bank details`);
            }
          }

          if (typeof keyDetails === "object" && keyDetails.verified === false) {
            if (isValNull(keyDetails.rejection_reason)) {
              errors.push(
                `Please enter rejection reason for ${innerKey
                  .split("_")
                  .join(" ")
                  .toUpperCase()}`
              );
            }
          }
          if (
            typeof keyDetails === "object" &&
            keyDetails.value !== undefined &&
            !excludedKeys.includes(outerKey) &&
            keyDetails.value !== null
          ) {
            if (isValNull(keyDetails.value)) {
              errors.push(
                `Please input ${innerKey
                  .split("_")
                  .join(" ")
                  .toUpperCase()} value`
              );
            }
          }
          if (
            typeof keyDetails === "object" &&
            keyDetails.zip_code !== undefined &&
            keyDetails.verified !== false
          ) {
            if (isValNull(keyDetails.zip_code)) {
              errors.push(
                `Please input ${innerKey
                  .split("_")
                  .join(" ")
                  .toUpperCase()} zip code`
              );
            }
          }
          if (
            typeof keyDetails === "object" &&
            keyDetails.city !== undefined &&
            keyDetails.verified !== false
          ) {
            if (isValNull(keyDetails.city)) {
              errors.push(
                `Please input ${innerKey
                  .split("_")
                  .join(" ")
                  .toUpperCase()} city`
              );
            }
          }
          if (
            typeof keyDetails === "object" &&
            keyDetails.state_id !== undefined &&
            keyDetails.verified !== false
          ) {
            if (isValNull(keyDetails.state_id)) {
              errors.push(
                `Please input ${innerKey
                  .split("_")
                  .join(" ")
                  .toUpperCase()} state`
              );
            }
          }
          if (
            typeof keyDetails === "object" &&
            checkDocTypeFilled.includes(innerKey) &&
            keyDetails.doc_type !== undefined
          ) {
            if (isValNull(keyDetails.doc_type)) {
              errors.push(
                `Please select ${innerKey
                  .split("_")
                  .join(" ")
                  .toUpperCase()} type from drop down`
              );
            }
          }
        });
      }
    });
  }
  return errors;
};
